import { Node, nodeInputRule } from '@tiptap/core';
import { VueNodeViewRenderer } from '@tiptap/vue-3';
import EditorVideo from 'shared/components/EditorVideo.vue';
import { uploadVideoPlugin } from 'shared/components/upload-video';

export const inputRegex = /(?:^|\s)(!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\))$/;

export default ({ uploadFn, hasStorage, fileTypes, eventBus }) => Node.create({
  name: 'video',

  addOptions() {
    return {};
  },

  inline() {
    return false;
  },

  atom: true,
  selectable: true,

  group() {
    return 'block';
  },

  draggable: true,

  addAttributes() {
    return {
      src: { default: null },
      alt: { default: null },
      name: { default: null },
      size: { default: null },
      autoOpen: { default: null },
      video: { default: null },
      uploader: { default: null },
    };
  },
  parseHTML: () => [
    {
      tag: 'video[src]',
      getAttrs: (dom) => {
        if (typeof dom === 'string') return {};
        const element = dom;

        return {
          src: element.getAttribute('src'),
          alt: '',
          name: '',
        };
      },
    },
  ],

  addNodeView() {
    return VueNodeViewRenderer(EditorVideo);
  },

  addCommands() {
    return {
      setVideo:
          (attrs) => ({ state, dispatch }) => {
            const { selection } = state;
            const position = selection.$head
              ? selection.$head.pos
              : selection.$to.pos;

            const node = this.type.create(attrs);
            const transaction = state.tr.insert(position, node);
            return dispatch(transaction);
          },
    };
  },
  addInputRules() {
    return [
      nodeInputRule({
        find: inputRegex,
        type: this.type,
        getAttributes: (match) => {
          const [, , alt, src, title] = match;
          return {
            src,
            alt,
            title,
          };
        },
      }),
    ];
  },
  addProseMirrorPlugins() {
    return [uploadVideoPlugin(uploadFn, hasStorage, fileTypes, eventBus)];
  },
});
